// provides a circuit breaker value via the systems table that the frontend can query
export enum SystemStatus {
    Enabled = "enabled",
    Disabled = "disabled",
}

// drives the sort key of the table and can be used to increase granularity for which general group has access
export enum SystemGroup {
    All = "all",
}

export enum SystemsId {
    HotspotDetectionEngine = "hotspotDetectionEngine",
    InfraredImageUploads = "infraredImageUploads",
    FirePerimeterUploads = "firePerimeterUploads",
}
